import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@nazka/nazka.mapframe.components'
import { useTranslation } from '@utils/i18n/i18n.consumers';
import Navbar from '../../components/Navbar/Navbar'
import ScreenNotSupported from '../../components/ScreenNotSupported/ScreenNotSupported'

import './landing-page.styl'

function LandingPage() {
  const navigate = useNavigate()
  const { t } = useTranslation()
  return (
    <div className="landing-page">
      <ScreenNotSupported />
      <Navbar landing explore />
      <div className="landing-page__wrapper">
        <div className="landing-page__header">
          <div className="landing-page__header__desktop">
            <div className="landing-page__header__content">
              <h1>Climate Champions</h1>
              <p>
                {t('In Kasungu, Malawi, young people, especially girls and young women, face significant challenges due to the effects of climate change. Limited access to information, education, and digital resources restricts their opportunities to participate in climate action.  Despite national policies that promote youth participation, true inclusion often falls short.')}
              </p>
              <Button
                css={{
                  borderRadius: '6px',
                  color: 'white',
                  marginTop: '2em',
                  '&:hover': {
                    color: 'white',
                  },
                }}
                onClick={() => navigate('/explore')}
              >
                {t('Explore climate')}
              </Button>
            </div>
            <div className="landing-page__header__desktop-cover">
              <div className="landing-page__header__desktop-cover__content">
                <img src="/img/coursemoduleimages/storycard.webp" alt="" />
                <p>{t('Introduction of proper farming methods along the river banks to avoid soil erosion that leads to siltation of the river...')}</p>
              </div>
            </div>
          </div>
          {/* <div className="landing-page__header__partners">
            <div className="landing-page__header__partners__wrapper">
              <div className="landing-page__header__partners__funded">
                <span>{t('Funded by')}</span>
                <a href="https://www.vlaanderen.be/en/environment/flanders-international-climate-action-programme" target="_blank" rel="noreferrer"><img src="/img/logo/flanders.jpg" /></a>
              </div>
              <div className="landing-page__header__partners__content">
                <span>{t('Partners')}</span>
                <div className="landing-page__header__partners__content__logos">
                  <a href="https://climatescale.com/" target="_blank" rel="noreferrer"><img src="/img/logo/climatescale.svg" /></a>
                  <a href="https://plan-international.org/" target="_blank" rel="noreferrer"><img src="/img/logo/plan.svg" /></a>
                  <a href="https://nazka.be/" target="_blank" rel="noreferrer"><img src="/img/logo/nazkalogo.png" /></a>
                </div>
              </div>
            </div>
          </div> */}
        </div>
        <div className="landing-page__section">
          <div className="landing-page__section__content__wrapper">
            <img src="/img/coursemoduleimages/whoAre.jpg" />
            <div className="landing-page__section__content">
              <h2>
                {t('Who are the')}
                <br />
                {' '}
                {t('Climate')}
                {' '}
                <span className="landing-page__section__content__highlight">
                  {t('Champions?')}
                  <div className="landing-page__section__rectangle" />
                </span>
              </h2>
              <p>
                {t('Adolescents and youth, particularly those in rural areas, are at the forefront of the climate crisis, driving climate action. Though they face barriers such as limited internet access, gender inequality, and a lack of trained educators, their resilience and motivation drives them to engage in climate solutions. Girls and young women, often the most affected, are rising as leaders in awareness and adaptation efforts.')}
              </p>
            </div>
          </div>
        </div>

        <div className="landing-page__section__list">
          <div className="landing-page__section__list__wrapper">
            <div className="landing-page__section__list__content">
              <h2>{t('What does the Climate Champions Project do?')}</h2>
              <ul className="landing-page__section__list__ul">
                <li>
                  {t('Developing inclusive climate education: Tailored, gender-sensitive education programs are being created for youth and communities, both online and offline.')}
                </li>
                <li>
                  {t('Empowering with technology: A mobile application links local climate data to practical adaptation strategies.')}
                </li>
                <li>
                  {t('Building advocacy skills: Youth are trained in communication and advocacy. Through a quiz, they can  test their knowledge of climate change in a fun and interactive way.')}
                </li>
                <li>
                  {t('Training leaders: Local authorities receive training on gender equality and youth inclusion to reinforce long-term change.')}
                </li>
              </ul>
            </div>
            <img className="landing-page__section__list__img" src="/img/coursemoduleimages/whatwedo.jpg" alt="what we do" />
          </div>
        </div>
        {/* <div className="landing-page__section__video">
        <h3>{t('Empowering youth to understand climate change in Malawi')}</h3>
      </div> */}
        <footer className="landing-page__footer">
          <p style={{ fontWeight: 'bold' }}>{t('Empowering youth to understand climate change in Malawi')}</p>
          <div className="landing-page__footer__partners">
            <div className="landing-page__header__partners__funded">
              <span>{t('Funded by')}</span>
              <a href="https://www.vlaanderen.be/en/environment/flanders-international-climate-action-programme" target="_blank" rel="noreferrer"><img src="/img/logo/flanders.jpg" /></a>
            </div>
            <div className="landing-page__header__partners__content">
              <span>{t('Partners')}</span>
              <div className="landing-page__header__partners__content__logos">
                <a href="https://climatescale.com/" target="_blank" rel="noreferrer"><img src="/img/logo/climatescale.svg" /></a>
                <a href="https://plan-international.org/" target="_blank" rel="noreferrer"><img src="/img/logo/plan.svg" /></a>
                <a href="https://nazka.be/" target="_blank" rel="noreferrer"><img src="/img/logo/nazkalogo.png" /></a>
              </div>
            </div>
          </div>
          <div className="landing-page__footer-final">
            <p>
              {t('© 2025 Nazka Mapps — and this website is our own creation <a href="https://legal.nazka.be/docs/en/terms-of-use/">terms of use</a> | <a href="https://legal.nazka.be/docs/en/privacy-policy/">privacy</a>')}
            </p>
          </div>
        </footer>
      </div>
    </div>
  )
}

export default LandingPage